import { RouteObject } from 'react-router';

import { DefaultLayout } from '@/ui/pages/app/components/layouts/DefaultLayout';
import { EditProjectFestival } from '@/ui/pages/app/project/festival/edit-project/EditProjectFestival';
import { ProjectFestival } from '@/ui/pages/app/project/festival/project/ProjectFestival';
import { ProjectSector } from '@/ui/pages/app/project/festival/project-sector/ProjectSector';
import { ProjectsFestival } from '@/ui/pages/app/project/festival/projects/ProjectsFestival';

import {
  editProjectLoader,
  festivalIndexLoader,
  projectLoader,
  projectsLoader,
  sectorLoader,
} from './festivalLoaders';

export const festivalRoutes: RouteObject[] = [
  {
    path: 'projects/festival',
    loader: festivalIndexLoader,
    children: [
      {
        path: '',
        loader: projectsLoader,
        element: (
          <DefaultLayout>
            <ProjectsFestival />
          </DefaultLayout>
        ),
      },
      {
        path: ':id',
        loader: projectLoader,
        element: (
          <DefaultLayout enableMargin={false}>
            <ProjectFestival />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/edit',
        loader: editProjectLoader,
        element: (
          <DefaultLayout>
            <EditProjectFestival />
          </DefaultLayout>
        ),
      },
      {
        path: ':id/sector',
        loader: sectorLoader,
        element: (
          <DefaultLayout>
            <ProjectSector />
          </DefaultLayout>
        ),
      },
    ],
  },
];
